import { Processor } from './processors-model';

export const processorsMapper = (apiData: any): Processor[] => {
  return apiData;
};
